<script>
import CampaignApi from "@/services/campaign-api";
import CustomersApi from "@/services/customers-api";
import UsersApi from "@/services/users-api";

export default {
    props : {

    },

  computed: {
    role() {
      return this.$cookies.get("userr");
    },
  },

  data() {
    return {

      campaignList:null,
      pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
      customersList:[],
      selectedCustomer:null,
      simulatedCustomerUpdated: false,
      isCampaignTableBusy:false,

    };
  },
  mounted() {

    if(this.role == 0 ){
      this.findCampaignByCurrentCustomer()
    }
    
    if(this.role == 1){
      this.getCustomers()
    }

    

  },

  watch:{
    selectedCustomer:function(){
      this.campaignList = []
      if(this.selectedCustomer != null){
        this.setSimulatedCustomer()
      }else{
        this.selectedCustomer = this.customersList[0]
      }

    }
  },


  methods: {

    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
          response => {
          this.customersList=response;
          this.selectedCustomer = this.customersList[0]
        }
      )
    },

    setSimulatedCustomer(){
      UsersApi.setSimulatedCustomer(this.selectedCustomer.id).then(
          response => {
          this.simulatedCustomerUpdated=response;
          this.reportingCustomerKey ++
          }
      ).finally(() => {
        this.findCampaignByCurrentCustomer()
      });
    },

    setCampaign(campaign) {
        this.$store.dispatch("menu/setStateFromCampaign",campaign);
        this.$emit("closeModal");
    },

    findCampaignByCurrentCustomer(){
      this.isCampaignTableBusy = true 
      CampaignApi.findCampaignByCurrentCustomer(this.pagemodelMain.currentPage, this.pagemodelMain.perPage).then(result =>{
              if(result){

                this.campaignList= result.list
                this.pagemodelMain.totalRows = result.total;
                this.pagemodelMain.currentPage = result.page;
                this.pagemodelMain.perPage = result.pageSize;
                this.pagemodelMain.pageSize = result.pageSize;

                this.isCampaignTableBusy = false 

              }

            })
        },



  },
};
</script>

<template>     

  <div>
    <div v-if="this.role == 1">
        <h5 class="text-uppercase font-weight-bold text-dark mb-1">
          {{ $t('reporting.customer.cardTitle') }}
        </h5>

        <div class="text-muted text-uppercase font-size-13 mb-4">
          {{ $t('reporting.customer.campaign') }}
        </div>

        <b-form-group class="mb-0">
          <v-select
            class="fancy-select col-12"
            :options="customersList"
            :placeholder="$t('lists.customers.label')"
            label="name"
            v-model="selectedCustomer"
          >
            <span slot="no-options">
              {{ $t('lists.emptyLists.label') }}
            </span>
          </v-select>
        </b-form-group>
    </div>

    <div class="mt-4">
      <div v-if="isCampaignTableBusy" class="text-center py-5">
        <b-spinner label="Chargement..." variant="primary"></b-spinner>
      </div>

      <div v-else-if="campaignList && campaignList.length">
        <div v-for="campaign in campaignList" :key="campaign.id" class="mb-3">
          <div class="d-flex align-items-center justify-content-between">
            <div class="pr-3">
              <h5 class="font-weight-bold text-dark text-uppercase mb-1">
                {{ campaign.name }}
              </h5>

              <div class="d-flex align-items-center gap-3 flex-wrap">
                <span class="text-muted text-uppercase font-size-12">
                  {{ campaign.customerName }}
                </span>

                <span class="divider">•</span>

                <span class="text-muted font-size-12">
                  {{ $t('periode.start') }}
                  <strong>{{ campaign.start }}</strong>
                </span>

                <span class="divider">•</span>

                <span class="text-muted font-size-12">
                  {{ $t('periode.end') }}
                  <strong>{{ campaign.end }}</strong>
                </span>
              </div>
            </div>

            <b-button
              :disabled="isCampaignTableBusy"
              variant="outline-primary"
              size="sm"
              class="text-uppercase font-weight-bold px-3"
              @click="setCampaign(campaign)"
            >
              {{ $t('campaign.change') }}
            </b-button>
          </div>
        </div>
      </div>

      <div v-else class="text-center text-muted py-3">
        {{ $t('campaign.noCampaigns') }}
      </div>
    </div>


  </div>
</template>


<style scoped>
.opacity-50 {
  opacity: 0.5;
}

.pointer-events-none {
  pointer-events: none;
}

::v-deep .fancy-select .vs__dropdown-toggle {
  border-radius: 10px;
  min-height: 44px;
  padding: 6px 12px;
  border: 1px solid #e1e5eb;
  background: #ffffff;
  transition: all 0.2s ease;
}

::v-deep .fancy-select .vs__dropdown-toggle:hover {
  border-color: #0d6efd;
}

::v-deep .fancy-select .vs__selected {
  font-weight: 600;
  color: #212529;
}

::v-deep .fancy-select .vs__search {
  color: #6c757d;
}

::v-deep .fancy-select .vs__dropdown-menu {
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}

</style>